import Lottie from "lottie-react";
import notFoundAnimation from "../../assets/lottie/not-found-lottie.json";
import style from "./NotFound.module.css"
import {Button} from "@mui/material";
import {useNavigate} from "react-router-dom";

export default function NotFound() {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate("/dashboard");
    }
    return <div className="container">
        <div className={style.notFoundBanner}>
            <div>
                <h1>Ooops!</h1>
                <p>Quello che cerchi non è disponibile.</p>
                <Button variant={"contained"} color={"primary"} onClick={handleClick}>Torna alla home!</Button>
            </div>
            <div style={{width: 260}}>
                <Lottie animationData={notFoundAnimation} loop={false}/>
            </div>
        </div>
    </div>
}
